export const doLogin = (account) => ({
  type:"LOGIN",
  account
})

export const doLogout = () => ({
  type:"LOGOUT"
})
